module.exports = __webpack_public_path__ + "img/example_1.3d80a3a6.png";